/**
 * moneyUtils.js
 *
 * Campos de valor em reais digitados como no Brasil: a pessoa escreve "1.200,99"
 * e o app grava 1200.99; o campo mostra sempre duas casas ("170,50").
 */

/**
 * Texto digitado -> número em reais. Aceita "150", "170,50", "170.50", "1.200" e
 * "1.200,99" (o "R$" e espaços são ignorados): com vírgula, ela é o decimal e os
 * pontos são milhar; só com ponto, ele é decimal, a não ser que venha seguido de
 * três dígitos ("1.200" = mil e duzentos). Vazio -> 0; null quando não dá para ler.
 */
export function parseMoney(text) {
  const value = String(text ?? '').replace(/R\$|\s/g, '');
  if (value === '') return 0;
  let normalized = value;
  if (value.includes(',')) normalized = value.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(value)) normalized = value.replace(/\./g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(normalized)) return null;
  return Number(normalized);
}

/** Número em reais -> texto do campo com duas casas: 170.5 -> "170,50", 1200 -> "1.200,00". */
export function formatMoneyInput(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return '';
  return number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Mantém no campo só dígitos, ponto e vírgula (o que parseMoney lê). */
export function cleanMoneyTyping(text) {
  return String(text ?? '').replace(/[^\d.,]/g, '').slice(0, 14);
}
